module.exports = __webpack_public_path__ + "img/logo-whatsapp.1f3b468b.png";